import React, { Component } from 'react';
import { connect } from 'react-redux';

import { message } from 'antd';
import { browserHistory } from 'react-router';
import {
  queryCustomCategory,
  queryCustomDepartmentInfo,
  querySaveDepartmentCustom,
} from '@api/crm/crm';
import FormCustom from './FormCustom';

class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = { data: {} };
  }

  componentDidMount() {
    this.getDetail();
  }

  handleAdd = params => {
    params.uuid = this.props.params.uuid;
    querySaveDepartmentCustom(params).then(res => {
      if (res.statusCode === 200) {
        browserHistory.go(-1);
      } else {
        message.error(res.message);
      }
    });
  };

  getDetail = () => {
    queryCustomDepartmentInfo(this.props.params.uuid).then(res => {
      if (res.statusCode === 200) {
        const data = res.data.customs;
        data.region = [data.province, data.city];
        data.category = [data.category1, data.category2];
        // this.initCategory(data.category1)
        this.setState({
          data,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  initCategory = key => {
    queryCustomCategory(key).then(() => {});
  };

  componentWillReceiveProps(nextProps) {
    this.setState({ data: nextProps.data });
  }

  render() {
    const { data } = this.state;
    return (
      <div>
        <FormCustom
          ref={form => {
            this.form = form;
          }}
          handleSubmit={this.handleAdd}
          data={data}
        />
      </div>
    );
  }
}

export default connect(state => ({ organization: state.organization }))(BaseForm);



// WEBPACK FOOTER //
// ./src/components/crm/custom/department/PageEdit.js